import { animate, style, transition, trigger } from '@angular/animations';
import { Component, computed, input } from '@angular/core';
import { AIState } from 'stream-chat';

@Component({
  selector: 'app-ai-status',
  imports: [],
  templateUrl: './ai-status.component.html',
  styleUrl: './ai-status.component.scss',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(8px)' }),
        animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-8px)' }))]),
    ]),
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('200ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
    ]),
  ],
})
export class AiStatusComponent {
  channelID = input<string>();
  ai_status = input<AIState | ''>();
  status = computed(() => this.getAIStatusText());

  getAIStatusText() {
    switch (this.ai_status()) {
      case 'AI_STATE_THINKING':
        return 'Thinking...';
      case 'AI_STATE_CHECKING':
        return 'Checking...';
      case 'AI_STATE_WRITING':
        return 'Writing...';
      case 'AI_STATE_GENERATING':
        return 'Typing...';
      default:
        return '';
    }
  }
}
